module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "Newcombe House, Notting Hill Gate",
    url: process.env.ELEVENTY_ENV === 'dev' ? 'https://develop--newcombe-house.netlify.app' : 'https://www.newcombehouse.info',

    holding: {
        "brand": "https://via.placeholder.com/300x200?text=Brand+image",
        "message": "Website coming soon"
    },

    base: {
        "contact_address": "",
        "contact_number": "0800 246 5890 (free to call)",
        "contact_email": "contact@newcombehouse.info"
    },

    meta: {
        "defaultSocialImage": "/assets/images/social.jpg",
        "author": "",
        "description": "",
        "gtag": "G-9LN2NN7GN7",
        "gtm": "GTM-MNF97Z9"
    },

    form: {
        "register": {
            "catcher_id": "284079a525f83f3c3c27413467664437",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b",
            "honeypot": "35ae8f5f0df84d7efac741c517d8332b"
        },
        "feedback": {
            "catcher_id": "1d5b7190c47d43e0d88027ebb9af7c86",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b",
            "honeypot": "0481b96a65fe7f1f358f7019d9e9cd40"
        }
    },

    consultation: {
        "feedback_active": false,
        "start_datetime": "",
        "end_datetime": "",
        "closed_message": "This consultation is closed and is no longer accepting feedback.",

        // Consultation close countdown. If set to true, show countdown in site header
        "has_countdown": false,
        "countdown_end": "03/31/2022 23:59:59", // Date format MM/DD/YYYY HH:MM:SS

        "themes": [
            {
                "name": "General Issues",
                "url": "section-1",
                "feedback_url": '',
                "icon": "uncategorised",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "01-section"
            },
            {
                "name": "Specific Issues",
                "url": "section-2",
                "feedback_url": 'page-2/',
                "icon": "uncategorised",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "02-section"
            },
            {
                "name": "Consultation",
                "url": "section-3",
                "feedback_url": 'page-3/',
                "icon": "uncategorised",
                "question": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim.",
                "key": "03-section"
            },
        ]
    },

    downloads: [
        {
            "title": "Presentation to the RBKC Development Forum (September 2022)",
            "url": "/assets/images/Development-Forum-Presentation.pdf"
        },
        {
            "title": "Community newsletter (October 2022)",
            "url": "/assets/images/Newcombe_House_2pp.pdf"
        },
        {
            "title": "Boards shown at public exhibition (October 2022)",
            "url": "/assets/images/Polity-Newcombe-House-A1-Boards.pdf"
        },
        {
            "title": "Watch the webinar on the Demolition Transport Management Plan - existing planning permission (January 2023)",
            "videoId": "796690878",
            "type": "video"
        },
        {
            "title": "Community newsletter (March 2023)",
            "url": "/assets/images/Newcombe_House_Newsletter_No2_A4_2pp.pdf"
        },
        {
            "title": "Watch the webinar on the revised proposals (March 2023)",
            "videoId": "812730520",
            "type": "video"
        },
        {
            "title": "Boards shown at public exhibition (March 2023)",
            "url": "/assets/images/Polity-Newcombe-House-A1-Boards_March23_Final.pdf"
        },
        {
            "title": "Presentation to the RBKC Development Forum (March 2023)",
            "url": "/assets/images/22008-0701-230327-Development-Forum-Presentation.pdf"
        }
    ],

    planning: [
        {
            "title": "Design & Access Statement",
            "url": "https://jfd-polity.s3.eu-west-2.amazonaws.com/newcombe-house/Newcombe_House-DAS.pdf"
        },
        {
            "title": "Planning Statement",
            "url": "/assets/images/Newcombe-House-Planning-Statement.pdf"
        },
        {
            "title": "Transportation Assessment (Part 1)",
            "url": "/assets/images/Newcombe-House-Transport-Assessment-May-2023(Part1of2).pdf"
        },
        {
            "title": "Transportation Assessment (Part 2)",
            "url": "/assets/images/Newcombe-House-Transport-Assessment-May-2023(Part2of2).pdf"
        },
        {
            "title": "Daylight & Sunlight Report",
            "url": "/assets/images/Newcombe-House-Daylight-and-Sunlight-Report.pdf"
        },
        {
            "title": "Contextual Daylight & Sunlight Study",
            "url": "/assets/images/Contextual-Daylight-&-Sunlight-Study.pdf"
        },
        {
            "title": "Construction Management Plan",
            "url": "/assets/images/Newcombe-House-Construction-Traffic-Management-Plan-May2023.pdf"
        },
        {
            "title": "Demolition Traffic Management Plan",
            "url": "/assets/images/Newcombe-House-Demolition-Traffic-Management-Plan-May2023.pdf"
        },
        {
            "title": "Townscape & Visual Impact Assessment",
            "url": "/assets/images/Newcombe-House-Townscape-and-Visual-Impact-Assessment-June2023.pdf"
        },
        {
            "title": "Statement of Community Involvement",
            "url": "/assets/images/Newcombe_House_SCI.pdf"
        },
    ],

    latest_updates: [
        {
            "title": "Presentation made at community meeting descriving progress to date with works and future programmed activities over the next six months (May 2025)",
            "url": "/assets/images/Community-Liaison-Group-Newcombe-House-JRL-Progress-April2025.pdf"
        },
        {
            "title": "Presentation made at community meeting describing proposed minor amendments to the consented development (May 2025)",
            "url": "/assets/images/Newcombe-House-Minor-Material-Amendments-Summary.pdf"
        },
        {
            "title": "Community newsletter from Midgard City, the demolition and construction company for the site (May 2025)",
            "url": "/assets/images/Newcombe_House_Community_Newsletter_May_2025"
        },
        {
            "title": "Community newsletter from Midgard City, the demolition and construction company for the site (October 2024)",
            "url": "/assets/images/Newcombe-House-Community-Newsletter-October-2024.pdf"
        },
        {
            "title": "Community newsletter from Midgard City, the demolition and construction company for the site (September 2024)",
            "url": "/assets/images/Newcombe-House-Community-Newsletter-September-2024.pdf"
        },
        {
            "title": "Community newsletter from Midgard City, the demolition and construction company for the site (August 2024)",
            "url": "/assets/images/Newcombe-House-Community-Newsletter-August-2024.pdf"
        },
        {
            "title": "Community newsletter from Midgard City, the demolition and construction company for the site (July 2024)",
            "url": "/assets/images/Newcombe-House-Community-Newsletter-July-2024.pdf"
        },
        {
            "title": "Community newsletter from Midgard City, the demolition and construction company for the site (June 2024)",
            "url": "/assets/images/Newcombe-House-Community-Newsletter-June-2024.pdf"
        },
        {
            "title": "Plans showing temporary changes to pedestrian routes and bus stops to allow for scaffold erection on Kensington Church Street (June 2024)",
            "url": "/assets/images/Temporary-changes-on-Kensington-Church-Street.pdf"
        },
        {
            "title": "Status Update (April 2024)",
            "url": "/assets/images/Status-Update-Newcombe-House-April-2024.pdf"
        },
        {
            "title": "Communitv newsletter from Midgard City, the demolition and construction company for the site (April 2024)",
            "url": "/assets/images/Newsletter-April-2024.pdf"
        },
        {
            "title": "Presentation made at community meeting on future demolition and construction activities (April 2024)",
            "url": "/assets/images/Newcombe-House-presentation-April-2024.pdf"
        },
    ],

    faqs: [
        {
            "question": "Key element 1: Retention of Newcombe House tower",
            sections: [
                {
                    "text": "The existing Newcombe House tower would be retained and completely refurbished to provide office accommodation. The latest revisions (March 2023) do not change the proposed height - an additional three-storeys to make it 15-storeys, some three-storeys lower than the permitted scheme."
                },
                {
                    "text": "One of the consistent themes in community feedback on the initial proposals presented in the last quarter of 2022 was a desire to see an ‘open-air’ space on the Notting Hill Gate frontage around the  retained ‘Waterstones tree’ which would allow it to thrive. This has resulted in the complete removal of the previously proposed seven-storey frontage building and its undercroft. This now results in a ‘drawn back’ and more elegant tower design with a new look vertical expression as shown in the new visual in the image carousel of this website."
                },
                {
                    "text": "The revision to the tower is a fundamental change and the most significant which has resulted in response to the consultation that has taken place to date."
                }
            ]
        },
        {
            "question": "Key element 2: Ground floor public space and covered street",
            sections: [
                {
                    "text": "With the very latest (March 2023) changes to the tower, the public square on Notting Hill Gate will now be 71% open to the sky whilst before it was only 22%. Greater opportunity to green the square is also now possible, something which many people told us they favoured during the first stage of public consultation. There is also a wider and better connection to Uxbridge Street."
                },
                {
                    "text": "A lot of feedback was received from the local community about the practicalities and attractiveness of the proposed internal covered retail street which formed part of the initial proposals. This was accessed from Notting Hill Gate under the tower and via a further access on Kensington Church Street. As a result of comments received on this, it has been decided to remove this from the latest proposals. This in turn allows the building footprint to be drawn back a further 3m from the boundary with the underground line and the nearest properties on Jameson Street. It also provides space for a new covered colonnade stretching along Kensington Church Street, offering more space for pedestrians at street level, something many local people told us they would like to see included. The proposed arches were broadly supported in the feedback received and these are retained in the proposed colonnade."
                }
            ]
        },
        {
            "question": "Key element 3: Kensington Church Street and the existing Newcombe House surface car park",
            sections: [
                {
                    "text": "This is the entirely new development part of the proposals. The proposed buildings here extend southwards along Kensington Church Street and on the existing surface level car park. There is a ‘tiered’ approach to the building on the car park and the latest changes mean that this steps back some 21 to 27m  from the nearest properties on the other side of the underground line in Jameson Street. This is wider than adjacent streets and similar to the building to building width of Kensington Church Street"
                },
                {
                    "text": "The proposed uses in the latest (March 2023) proposal remain retail at ground level the length of the new colonnade with offices above. "
                },
                {
                    "text": "The proposed building heights along Kensington Church Street are unchanged at primarily six-storeys until the corner with Kensington Place where an eight-storey building is currently indicated. The design of the six storey element has evolved in response to feedback with the introduction of less regularity in window apertures and a variations in the roof parapet to provide a less repetitive façade.  There was significant community feedback received about housing a new doctor’s surgery in the eight-storey building and further detailed discussions have taken place with the NHS to agree requirements. There was broad community support for the inclusion of new high quality affordable homes in this building as well."
                }
            ]
        },
    ],

    hasMap: false,

    // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
    mapUrl: process.env.ELEVENTY_ENV === 'dev' ? '[STAGING LINK]' : '[PROD LINK]',

    // Bugsnag API Key
    bugsnagApiKey: 'f3d287d3c14161b3df5e9bcc5c6141c9',

    // Marker.io Key - replace this default key
    marker_io: '618d2de7be76ee21e8452764'
};